
import { useEffect, useState } from 'react';
import GoogleAnalytics from './GoogleAnalytics';

const STORAGE_KEY = 'vaguedemots-analytics-consent';
const GA_ID = 'G-0L2Q5KSMHY';

function removeAnalyticsCookies() {
  const hostname = window.location.hostname;

  const domains = [
    '',
    hostname,
    `.${hostname}`,
    'vaguedemots.fr',
    '.vaguedemots.fr',
  ];

  const cookieNames = document.cookie
    .split(';')
    .map(cookie => cookie.trim().split('=')[0])
    .filter(name =>
      name === '_ga' ||
      name === '_gid' ||
      name === '_gat' ||
      name.startsWith('_ga_')
    );

  for (const name of cookieNames) {
    for (const domain of domains) {
      const domainPart = domain
        ? `; domain=${domain}`
        : '';

      document.cookie =
        `${name}=; Max-Age=0; path=/${domainPart}; SameSite=Lax`;
    }
  }
}

export default function CookieConsent() {
  const [consent, setConsent] =
    useState<boolean | null | undefined>(undefined);

  const [settingsOpen, setSettingsOpen] = useState(false);

  useEffect(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);

      if (saved === 'accepted') {
        setConsent(true);
      } else if (saved === 'refused') {
        setConsent(false);
      } else {
        setConsent(null);
      }
    } catch {
      setConsent(null);
    }
  }, []);

  function saveConsent(accepted: boolean) {
    const analyticsWindow =
      window as unknown as Window & Record<string, unknown>;

    analyticsWindow[`ga-disable-${GA_ID}`] = !accepted;

    if (!accepted) {
      removeAnalyticsCookies();
    }

    try {
      localStorage.setItem(
        STORAGE_KEY,
        accepted ? 'accepted' : 'refused'
      );
    } catch {
      // Consentement conservé durant la session React.
    }

    setConsent(accepted);
    setSettingsOpen(false);
  }

  const showBanner = consent === null || settingsOpen;

  return (
    <>
      <GoogleAnalytics enabled={consent === true} />

      <button
        type="button"
        className="cookie-settings-button"
        onClick={() => setSettingsOpen(true)}
      >
        Gérer les cookies
      </button>

      {showBanner && (
        <div
          className="cookie-banner"
          role="region"
          aria-label="Préférences de confidentialité"
        >
          <div className="cookie-banner-content">
            <div>
              <h2>Votre confidentialité compte</h2>

              <p>
                Vague de Mots utilise, avec votre accord,
                Google Analytics pour comprendre la
                fréquentation du site et améliorer
                votre expérience.
              </p>

              <p>
                Vous pouvez accepter ou refuser ces cookies
                facultatifs, puis modifier votre choix
                à tout moment.
              </p>

              <a href="/politique-de-confidentialite">
                Politique de confidentialité
              </a>
            </div>

            <div className="cookie-actions">
              <button
                type="button"
                onClick={() => saveConsent(false)}
              >
                Refuser
              </button>

              <button
                type="button"
                className="cookie-accept"
                onClick={() => saveConsent(true)}
              >
                Accepter
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
